export const CAMPAIGN_TEMPLATES = [
    {
        id: 'nurse',
        name: 'Nurse',
        subject: 'Hire Qualified Nurses Easily on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Struggling to find qualified nurses? We’ve got you covered.

Hire experienced nurses for hospitals, clinics, or home care.
Access a wide pool of verified and skilled professionals.
Flexible hiring – full-time or part-time as per your needs.
Save time and ensure quality patient care.

No hassle. No delay. Just ready-to-work nurses.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'driver',
        name: 'Driver',
        subject: 'Find Experienced Drivers on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Looking for reliable drivers? We’ve got the right candidates.

Hire licensed and experienced drivers for personal or company use.
Skilled in local routes and safe driving practices.
Available for full-time, part-time, or temporary roles.
Reduce hiring time and get drivers ready to join immediately.

No hassle. No delay. Just professional drivers.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'doctors',
        name: 'Doctors',
        subject: 'Connect with Certified Doctors on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Finding the right doctors is difficult—we make it easy.

Connect with certified doctors across multiple specialties.
Ideal for clinics, hospitals, and healthcare centers.
Quick and direct hiring process.
Ensure quality healthcare with experienced professionals.

No hassle. No delay. Just trusted doctors.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'mechanic',
        name: 'Mechanic',
        subject: 'Hire Skilled Mechanics on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Need skilled mechanics? We’ve got experts ready.

Hire experienced mechanics for cars, trucks, and equipment.
Skilled in repair, maintenance, and diagnostics.
Suitable for garages and companies.
Fast hiring with ready-to-join professionals.

No hassle. No delay. Just skilled mechanics.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'domestic',
        name: 'Domestic Workers / Maids',
        subject: 'Find Trusted Domestic Workers on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Looking for trusted domestic workers? We make it simple.

Hire maids for cleaning, cooking, and childcare.
Access candidates from multiple nationalities.
Choose based on your exact home requirements.
Safe, reliable, and ready to join.

No hassle. No delay. Just dependable domestic help.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'caregivers',
        name: 'Caregivers',
        subject: 'Hire Professional Caregivers on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Need professional caregivers? We’re here to help.

Hire trained caregivers for elderly and patient care.
Experienced in home care and medical support.
Flexible hiring options available.
Trusted and verified profiles for your peace of mind.

No hassle. No delay. Just compassionate caregivers.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'electricians',
        name: 'Electricians',
        subject: 'Get Verified Electricians on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Facing issues finding skilled electricians? We’ve got solutions.

Hire qualified electricians for residential and commercial work.
Experts in installation, maintenance, and repairs.
Available for projects or full-time roles.
Fast and efficient hiring process.

No hassle. No delay. Just skilled electricians.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'plumbers',
        name: 'Plumbers',
        subject: 'Find Reliable Plumbers on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Need reliable plumbers? We’ve got professionals ready.

Hire experienced plumbers for repairs and installations.
Suitable for homes, offices, and large projects.
Quick access to skilled professionals.
Flexible hiring based on your needs.

No hassle. No delay. Just efficient plumbers.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'security',
        name: 'Security Guards',
        subject: 'Hire Trained Security Guards on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Looking for trusted security guards? We make hiring easy.

Hire trained guards for offices, homes, and events.
Disciplined and experienced personnel.
Flexible hiring options available.
Ensure safety with reliable professionals.

No hassle. No delay. Just dependable security staff.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'cleaners',
        name: 'Cleaners',
        subject: 'Book Professional Cleaners on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Need professional cleaners? We’ve got the right team.

Hire cleaners for homes, offices, and commercial spaces.
Experienced in deep cleaning and maintenance.
Flexible schedules available.
Fast and reliable service.

No hassle. No delay. Just efficient cleaning staff.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'construction',
        name: 'Construction Workers',
        subject: 'Find Skilled Construction Workers on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Finding construction workers is tough—we make it simple.

Hire skilled laborers and specialized workers.
Suitable for all types of construction projects.
Available for short-term and long-term work.
Reliable workforce ready to join immediately.

No hassle. No delay. Just hardworking professionals.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'office',
        name: 'Office Staff',
        subject: 'Hire Office Staff Quickly on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Need reliable office staff? We’ve got qualified candidates.

Hire admin, receptionists, and support staff easily.
Skilled and experienced professionals.
Easy filtering based on your requirements.
Quick and efficient hiring process.

No hassle. No delay. Just professional office staff.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'hospitality',
        name: 'Hospitality Staff',
        subject: 'Recruit Hospitality Staff on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Looking for hospitality staff? We’ve got top talent ready.

Hire chefs, waiters, housekeeping, and more.
Experienced and customer-focused professionals.
Suitable for hotels, restaurants, and cafes.
Flexible hiring options available.

No hassle. No delay. Just quality hospitality staff.

👉 Start hiring now on GulfWorker.net`
    },
    {
        id: 'delivery',
        name: 'Delivery Riders',
        subject: 'Hire Delivery Riders Fast on GulfWorker.net',
        message: `Greetings {name}! Hope you are doing well.
We are from GulfWorker.

Struggling to find reliable delivery riders? We’ve got you covered.

Hire experienced riders ready for immediate joining.
Skilled in local routes, fast delivery, and efficient logistics.
Flexible hiring options – full-time or part-time.
Save time, reduce hiring stress, and scale your operations quickly.

No hassle. No delay. Just ready-to-work riders.

👉 Start hiring now on GulfWorker.net`
    }
];
